gz-push-body-layout[isopen] div[slot='push-body-sidenav'] {
  height: 100%;
}

gz-generic-grid-smart-views {
  padding-left: calc(var(--spacer) + var(--spacer) / 2);
}
